import TextAreaWithTabs from "../../UI/TextAreaWithTabs/TextAreaWithTabs";
import React, {useState} from "react";
import * as actionTypes from "../../../store/actions/actionTypes";
import {useDispatch} from "react-redux";
import EditHistoryWrapper from "../../UI/EditHistoryPanel/EditHistoryWrapper";
import { Editor } from "@tinymce/tinymce-react";

const PatternDescriptionInput = ({token, pattern_description, descriptionUpdate, pattern_id}) => {
    const [activeHistory, setActiveHistory] = useState([]);

    const dispatch = useDispatch();

    function openUserProfile(userId) {
        dispatch({type: actionTypes.SELECT_USER, userId: userId});
        dispatch({type: actionTypes.OPEN_USER_MODAL});
    }

    const handleHistoryChange = (historyChange) => {
        if (historyChange) {
            if (pattern_description.description_id === historyChange.description_id) {
                descriptionUpdate(historyChange)
            } else {
                descriptionUpdate(pattern_description)
            }
        }
    }

    const handleActiveHistory = (activeHistories) => {
        setActiveHistory(activeHistories)
    }


    return <dl className="row">
        <dt className="col-sm-3"><label>Pattern Description<span style={{color: "red"}}> *</span></label></dt>
        <dd className="col-sm-9">
            <div className="example-games-block" key={"pattern-description-text-field"}>
                <div className={"example-description"}>
                    {/*<TextAreaWithTabs*/}
                    {/*    placeholder="Describe your pattern in detail."*/}
                    {/*    rows="4"*/}
                    {/*    value={pattern_description.description}*/}
                    {/*    onChange={(event) =>*/}
                    {/*        descriptionUpdate({...pattern_description, description: event.target.value})*/}
                    {/*    }*/}
                    {/*/>*/}


                    <Editor
                        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                        licenseKey='gpl'
                        //apiKey="xbzi0214a2p5xy8r9yu5i89rfwupddbj8814fqb683cw6zuh"
                        value={pattern_description.description}
                        init={{
                            menubar: false,
                            plugins: [
                                'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                            ],
                            toolbar: 'undo redo | blocks | ' +
                                'link bold italic forecolor | alignleft aligncenter ' +
                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                'removeformat | help'
                        }}
                        onEditorChange={(content, editor) => {
                                        descriptionUpdate({...pattern_description, description: editor.getContent()})
                        }}
                    />

                    <EditHistoryWrapper
                        style={{marginRight: 5, marginTop: 5}}
                        token={token}
                        history_id={pattern_description.history_id}
                        pattern_id={pattern_description.pattern_id}
                        component_id={pattern_description.description_id}
                        handleHistoryChange={handleHistoryChange}
                        handleActiveHistory={handleActiveHistory}
                        activeHistories={activeHistory}
                        component_text_field={pattern_description.description}
                        flag={"PATTERN_DESCRIPTION"}
                        component={pattern_description}
                        keyStr={"description-history"}
                        isActive={activeHistory.includes(pattern_description.description_id)}
                        openUserModal={() => {
                            openUserProfile(pattern_description.editor_user_id);
                        }}
                    />
                </div>
            </div>
        </dd>
    </dl>

}

export default PatternDescriptionInput;